module.exports = __webpack_public_path__ + "img/11.d400ddf8.jpg";